import React, { useEffect, useState } from "react";
import axios from "axios";
import ErrorMessages from "../../shared/errormessages/ErrorMessages"
import Sidebar from "../../shared/sidebar/Sidebar";
import Navbar from "../../shared/navbar/Navbar";
import ValidationMessage from "../../shared/validationmessage/ValidationMessage"

const ChangePassword = () => {
    const [errors, setErrors] = useState("");
    const [OldPassword, setOldPassword] = useState("")
    const [NewPassword, setNewPassword] = useState("")
    const [ConfirmPassword, setConfirmPassword] = useState("")
    const [validations, setValidations] = useState({
        OldPassword: [],
        NewPassword: [],
        ConfirmPassword: []
      });

    const resetValidations=()=>{
        setValidations({
          OldPassword: [],
          NewPassword: [],
          ConfirmPassword: []
        });
        setErrors("");
      }

    const resetPassword=()=> {
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
    
    const parseErrorResponse=(response)=>{
        if(response.data.errors){
            setErrors("");
            setValidations(response.data.errors);
          }
      }

    const handleSubmit = async e => {
        e.preventDefault();
        axios.post('/account/changepassword', {
            OldPassword: OldPassword,
            NewPassword: NewPassword,
            ConfirmPassword: ConfirmPassword
          }).then(function (response) {
            resetValidations();
            if(NewPassword == ConfirmPassword && response.data.status == "Success"){             
                alert(response.data.message);
                resetPassword();
            }
            else{
                setErrors(response.data.message);
            }
        })
        .catch(function (error) {
            parseErrorResponse(error.response);
    });
    }

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
      <Navbar title="Change Password" />
      <form onSubmit={handleSubmit} className="form">
      <ErrorMessages message={errors}/>
            <div className="form-group mt-3">
              <label >Old Password</label>
              <input type="password" id="OldPassword" className="form-control form-control-sm" value={OldPassword} onChange={e=> setOldPassword(e.target.value)} />
              <ValidationMessage field="OldPassword" errors={validations} />
            </div>
            <div className="form-group mt-3">
              <label >New Password</label>
              <input type="password" id="NewPassword" className="form-control form-control-sm" value={NewPassword} onChange={e=> setNewPassword(e.target.value)} />
              <ValidationMessage field="NewPassword" errors={validations} />
            </div>
            <div className="form-group mt-3">
              <label >Confirm Password</label>
              <input type="password" id="ConfirmPassword" className="form-control form-control-sm" value={ConfirmPassword} onChange={e=> setConfirmPassword(e.target.value)} />
              <ValidationMessage field="ConfirmPassword" errors={validations} />
            </div>
            <button type="submit" className="btn btn-primary btn-block submit-btn  mt-3">
              submit
            </button>
          </form>
    </div>
    </div>
  );
};

export default ChangePassword;
